import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../../Common/ButtonController';
import { GameModel } from '../../../Models/Game/GameModel';
import { GameLogic } from '../../../Logic/GameLogic';
import {
    GameEndControllerButton,
    IGameEndControllerButtonOptions,
} from './GameEndControllerButton';

export class GameEndController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('GameEndController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_END_SCREEN_JSON,
            libraryName: 'main',
            childControllers: {
                btn_close: {
                    instanceName: 'container.window.btn_close',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlayByQuery(
                                'container',
                                'window close',
                                false,
                                false
                            );
                            this.$queue.get('hide').addToQueue();
                        },
                    },
                },
            },
            modelWatch: {},
            queue: {
                hide: {
                    condition: time => time > 0.3,
                    action: () => {
                        this._gameLogic.showMenuScreen();
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        // const textArray = ['proactivity', 'responsibility', 'openness', 'attantion']
        // textArray.forEach(item => {
        //     this.gotoAndStopByQuery(`container.window.${item}`, "close")
        // }),
        this.$model.collectAchievements.forEach(item => {
            const achievements = item.toLowerCase();
            this.gotoAndStopByQuery(
                `container.window.${achievements}`,
                'open',
                false
            );
        }),
            ['restart', 'leaderboard', 'man_menu'].forEach((name: string) => {
                this.addChildController(
                    {
                        instanceName: `container.window.btn_${name}`,
                        view: GameEndControllerButton,
                        model: name,
                        options: <IGameEndControllerButtonOptions>{
                            name: name,
                            onClick: name => {
                                switch (name) {
                                    case 'restart':
                                        this._gameLogic.resetGameScreen();
                                        this._gameLogic.showGameScreen();
                                        break;

                                    case 'leaderboard':
                                        // TODO
                                        break;

                                    case 'man_menu':
                                        this._gameLogic.showMenuScreen();
                                        break;
                                }
                            },
                        },
                    },
                    name
                );
            });

        this.gotoAndPlayByQuery(
            'container',
            'window initialization',
            false,
            false
        );
        this.setTextByQuery(
            'container.window.txt_score',
            this.$model.player.score.toString()
        );
    }

    protected onLandscape(): void {
        this.display.scale.set(1.55);
        this.display.y = 25;
    }
}
